<template lang="pug">
  div#header.no-print
    header.no-print.main-header
      a(href="#menu" @click.stop.prevent="toggleMenu" v-if="isGuest === false")
      nav.main-header__nav
        a.section-name
          span.number {{ number}}
          span.name {{ $translate(title) }}
        span(
          v-if="$store.getters.userCan('show-site-name')"
        ) {{SITE_NAME}}
        //a.secton-subname
            a(href="#") Подраздел
      div.profile(v-if="isGuest === false" @click.stop="showProfileMenu = !showProfileMenu")
        a(v-if="SHOW_HIDDEN_FIELDS" @click.stop.prevent="resetUserToken") Reset token
        div(
        :style="profileFigBg"
        ).profile__fig
        div.profile__body {{userData.fullname ? userData.fullname : $translate('ФИО не установлены')}}
        div(:class="showProfileMenu ? 'open' : 'close'").profile__menu
          router-link(:to="{name: 'account.userProfile'}" tag="span" class="profile__menu-link") {{$translate('Личный кабинет')}}
          span(@click.prevent="logout" class="marker logoutLink profile__menu-link") {{$translate('Выйти')}}
</template>

<script>
  import url from '../../utils/url.js'
  import {SITE_NAME, ROOT_DOMAIN, SHOW_HIDDEN_FIELDS} from '../../config/config'

  export default {
    name: 'main-header',
    data () {
      return {
        showProfileMenu: false
      }
    },
    computed: {
      SITE_NAME () {
        return SITE_NAME
      },
      SHOW_HIDDEN_FIELDS () {
        return SHOW_HIDDEN_FIELDS
      },
      profileFigBg () {
        if (this.userData && this.userData.photo) {
          return `background-image:url('${ROOT_DOMAIN}${this.userData.photo}')!important;`
        }
        return ''
      },
      userData () {
        return this.$store.getters.userData
      },
      isGuest () {
        return this.$store.getters.isGuest
      },
      number () {
        return this.getFromMeta('number')
      },
      title () {
        return this.getFromMeta('title')
      }
    },
    created () {
      window.addEventListener('click', this.outerClick)
    },
    destroyed () {
      window.removeEventListener('click', this.outerClick)
    },
    methods: {
      resetUserToken () {
        const data = this.userData
        data.access_token = +new Date()
        this.$store.commit('userSetAuthData', data)
      },
      outerClick () {
        this.showProfileMenu = false
      },
      getFromMeta (attr) {
        if (this.$route.query.prevRoute) {
          if (this.$route.matched[0]) {
            return this.$route.matched[0].meta[attr]
          }
        } else {
          if (this.$route.matched[0] && this.$route.matched[0].meta && this.$route.matched[0].meta[attr]) {
            // if open child route, get title from root parent
            return this.$route.matched[0].meta[attr]
          } else if (this.$route.meta && this.$route.meta[attr]) {
            // if open main route
            return this.$route.meta[attr]
          }
        }
        return ''
      },
      toggleMenu () {
        this.$store.commit('toggleMenu')
      },
      logout () {
        this.$store.commit('userSetRedirectUrl', url.getRoute(this.$route))
        this.$store.dispatch('userLogout').then(() => {
          this.$router.push('/login')
        })
      }
    }
  }
</script>

